import _extends from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.set-interval.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.set-timeout.js';
import { __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import { omit } from 'lodash';
import ResizeObserver from 'rc-resize-observer';
import throttleByAnimationFrame from '../../utils/throttleByAnimationFrame.js';
import classNames from 'classnames';
import { getDefaultTarget, getTargetRect, getFixedTop, getFixedBottom } from '../utils/index.js';
import '../styles/index.less.js';

var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
var AffixStatusEnum;
(function (AffixStatusEnum) {
  AffixStatusEnum[AffixStatusEnum["None"] = 0] = "None";
  AffixStatusEnum[AffixStatusEnum["Prepare"] = 1] = "Prepare";
})(AffixStatusEnum || (AffixStatusEnum = {}));
var TiAffix = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a;
  var style = props.style,
    offsetTop = props.offsetTop,
    offsetBottom = props.offsetBottom,
    className = props.className,
    rootClassName = props.rootClassName,
    children = props.children,
    target = props.target,
    onChange = props.onChange;
  var _b = React.useState(false),
    lastAffix = _b[0],
    setLastAffix = _b[1];
  var _c = React.useState(),
    affixStyle = _c[0],
    setAffixStyle = _c[1];
  var _d = React.useState(),
    placeholderStyle = _d[0],
    setPlaceholderStyle = _d[1];
  var status = React.useRef(AffixStatusEnum.None);
  var prevTarget = React.useRef(null);
  var prevListener = React.useRef();
  var placeholderNodeRef = React.useRef(null);
  var fixedNodeRef = React.useRef(null);
  var timer = React.useRef(null);
  var targetFunc = target !== null && target !== void 0 ? target : getDefaultTarget;
  var internalOffsetTop = offsetBottom === undefined && offsetTop === undefined ? 0 : offsetTop;
  // =================== Measure ===================
  var measure = function measure() {
    if (status.current !== AffixStatusEnum.Prepare || !fixedNodeRef.current || !placeholderNodeRef.current || !targetFunc) {
      return;
    }
    var targetNode = targetFunc();
    if (targetNode) {
      var newState = {
        status: AffixStatusEnum.None
      };
      var placeholderRect = getTargetRect(placeholderNodeRef.current);
      if (placeholderRect.top === 0 && placeholderRect.left === 0 && placeholderRect.width === 0 && placeholderRect.height === 0) {
        return;
      }
      var targetRect = getTargetRect(targetNode);
      var fixedTop = getFixedTop(placeholderRect, targetRect, internalOffsetTop);
      var fixedBottom = getFixedBottom(placeholderRect, targetRect, offsetBottom);
      if (fixedTop !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          top: fixedTop,
          width: placeholderRect.width,
          height: placeholderRect.height
        };
        newState.placeholderStyle = {
          width: placeholderRect.width,
          height: placeholderRect.height
        };
      } else if (fixedBottom !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          bottom: fixedBottom,
          width: placeholderRect.width,
          height: placeholderRect.height
        };
        newState.placeholderStyle = {
          width: placeholderRect.width,
          height: placeholderRect.height
        };
      }
      newState.lastAffix = !!newState.affixStyle;
      if (lastAffix !== newState.lastAffix) {
        onChange === null || onChange === void 0 ? void 0 : onChange(newState.lastAffix);
      }
      status.current = newState.status;
      setAffixStyle(newState.affixStyle);
      setPlaceholderStyle(newState.placeholderStyle);
      setLastAffix(newState.lastAffix);
    }
  };
  var prepareMeasure = function prepareMeasure() {
    status.current = AffixStatusEnum.Prepare;
    measure();
  };
  var updatePosition = throttleByAnimationFrame(function () {
    prepareMeasure();
  });
  var lazyUpdatePosition = throttleByAnimationFrame(function () {
    // Check position change before measure to make Safari smooth
    if (targetFunc && affixStyle) {
      var targetNode = targetFunc();
      if (targetNode && placeholderNodeRef.current) {
        var targetRect = getTargetRect(targetNode);
        var placeholderRect = getTargetRect(placeholderNodeRef.current);
        var fixedTop = getFixedTop(placeholderRect, targetRect, internalOffsetTop);
        var fixedBottom = getFixedBottom(placeholderRect, targetRect, offsetBottom);
        if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
          return;
        }
      }
    }
    // Directly call prepare measure since it's already throttled.
    prepareMeasure();
  });
  var addListeners = function addListeners() {
    var listenerTarget = targetFunc === null || targetFunc === void 0 ? void 0 : targetFunc();
    if (!listenerTarget) {
      return;
    }
    TRIGGER_EVENTS.forEach(function (eventName) {
      var _a;
      if (prevListener.current) {
        (_a = prevTarget.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(eventName, prevListener.current);
      }
      listenerTarget === null || listenerTarget === void 0 ? void 0 : listenerTarget.addEventListener(eventName, lazyUpdatePosition);
    });
    prevTarget.current = listenerTarget;
    prevListener.current = lazyUpdatePosition;
  };
  var removeListeners = function removeListeners() {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    var newTarget = targetFunc === null || targetFunc === void 0 ? void 0 : targetFunc();
    TRIGGER_EVENTS.forEach(function (eventName) {
      var _a;
      newTarget === null || newTarget === void 0 ? void 0 : newTarget.removeEventListener(eventName, lazyUpdatePosition);
      if (prevListener.current) {
        (_a = prevTarget.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(eventName, prevListener.current);
      }
    });
    updatePosition.cancel();
    lazyUpdatePosition.cancel();
  };
  React.useImperativeHandle(ref, function () {
    return {
      updatePosition: updatePosition
    };
  });
  // mount & unmount
  React.useEffect(function () {
    // [Legacy] Wait for parent component ref has its value.
    // We should use target as directly element instead of function which makes element check hard.
    timer.current = setTimeout(addListeners);
    return function () {
      return removeListeners();
    };
  }, []);
  React.useEffect(function () {
    addListeners();
  }, [target, affixStyle]);
  React.useEffect(function () {
    updatePosition();
  }, [target, offsetTop, offsetBottom]);
  var wrapStyle = __assign(__assign({}, style), {
    '--ti-affix-zIndex': 1000
  });
  var otherProps = omit(props, ['offsetTop', 'offsetBottom', 'target', 'onChange', 'rootClassName']);
  var mergeCls = classNames(rootClassName, (_a = {}, _a['ti-affix'] = !!affixStyle, _a));
  return /*#__PURE__*/React.createElement(ResizeObserver, {
    onResize: updatePosition
  }, /*#__PURE__*/React.createElement("div", _extends({
    style: wrapStyle,
    className: className,
    ref: placeholderNodeRef
  }, otherProps), affixStyle && /*#__PURE__*/React.createElement("div", {
    style: placeholderStyle,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: mergeCls,
    ref: fixedNodeRef,
    style: affixStyle
  }, /*#__PURE__*/React.createElement(ResizeObserver, {
    onResize: updatePosition
  }, children))));
});

export { AffixStatusEnum, TiAffix as default };
